import { AssetDto, AssetImageTypeDataDto } from '@picflow/types';
import { exifKeys, getExifValue } from 'src/app/lib/extract-exif';
import { DisplayGuestEmailDto, DisplayUserEmailDto } from 'src/app/services/visitor.service';
import { Filter } from '../interfaces/filter.interface';

export const filterAssets = (
  assets: AssetDto[],
  filters: Filter[],
  searchTerm: string,
  exactMatch = false,
  people?: { userOrGuest: DisplayUserEmailDto | DisplayGuestEmailDto; assetIds: string[] }[]
) => {
  // Filters
  assets = assets.filter(asset => !filters.find(filter => singleFilter(filter, asset, people)));

  if (searchTerm) {
    if (exactMatch) {
      assets = assets.filter(asset => {
        if (asset.version_data.asset_name.toLowerCase() === searchTerm.toLowerCase()) return true;
        if (asset.version_data.asset_name.toLowerCase().split('.')[0] === searchTerm.toLowerCase()) return true;
        return false;
      });
    } else {
      // Search term
      const terms = searchTerm.split(' ');
      assets = assets.filter(asset => {
        return !!terms.find(term => asset.version_data.asset_name.includes(term));
      });
    }
  }
  return assets;
};

export const singleFilter = (
  filter: Filter,
  asset: AssetDto,
  people?: { userOrGuest: DisplayUserEmailDto | DisplayGuestEmailDto; assetIds: string[] }[]
): boolean => {
  if (filter.key === 'people') {
    // todo, see if people array has person with this asset id
    if (!people) return true;
    return !filter.values.some(value => {
      const person = people.find(p => p.userOrGuest['id'] === value);
      return person && person.assetIds.includes(asset.id);
    });
  }

  if (filter.key === 'tags') {
    return !filter.values.some(value => {
      return (asset['tags'] as AssetDto[]).some(tag => tag.id === value);
    });
  }

  if (filter.key === 'comments') {
    if (filter.values.includes('with') && asset['text_comments_total_count'] > 0) return false;
    if (filter.values.includes('without') && asset['text_comments_total_count'] === 0) return false;
    return true;
  }

  if (filter.key === 'annotations') {
    if (filter.values.includes('with') && asset['annotation_comments_total_count'] > 0) return false;
    if (filter.values.includes('without') && asset['annotation_comments_total_count'] === 0) return false;
    return true;
  }

  let value = asset[filter.key];
  const data = <AssetImageTypeDataDto>asset.version_data?.data;
  if (exifKeys.includes(filter.key)) value = getExifValue(data?.exif, filter.key);
  if (value === undefined) value = null;

  if (filter.values.includes('truthy') && value) return false;
  if (filter.values.includes('falsy') && !value) return false;

  if (typeof value !== 'string') value = JSON.stringify(value);

  const resp = !filter.values
    .map(v => {
      return typeof v !== 'string' ? JSON.stringify(v) : v;
    })
    .find(v => v === value);

  return resp;
};
